import React, { useEffect } from 'react';

import ReactDOM from 'react-dom';
import { ButtonPrimary } from '../../StyledComponent';
import {
  PopupAddRepairContainer,
  FieldContainer,
  ButtonsContainer,
  HeaderContainer,
  InfosContainer,
  BodyContainer,
} from './styles';

import { PageTitle } from '../../../Pages/Sindico/styles';
import { PageOverlay } from '../../MessagePopup/style';
import AttachDocuments from '../NovaSolicitacao/AttachDocuments';
import CloseButton from '../../Reutilizaveis/CloseButton';
import DropDown from '../../Reutilizaveis/DropDown';
import AlertMessage from '../AlertMessage';

const AddReparoPopup = ({
  tema,
  apontamentoSelecionado,
  setApontamentoSelecionado,
  apontamentos,
  savingChanges,
  handleAddReparo,
  isSindico,
  validWarranty,
  setValidWarranty,
  verificaSeDisabilitado,
  setShowAddReparoPopup,
  documents,
  setDocuments,
  descricao,
  setDescricao,
}) => {
  useEffect(() => {
    return () => {
      setDocuments([]);
      setDescricao('');
      setApontamentoSelecionado(
        'Selecione uma categoria de apontamento que melhor descreva o seu reparo.'
      );
      setValidWarranty(false);
    };
  }, []);
  return ReactDOM.createPortal(
    <PageOverlay>
      <PopupAddRepairContainer>
        <InfosContainer>
          <HeaderContainer>
            <div>
              <PageTitle>Novo caso de reparo</PageTitle>
              <CloseButton
                tamanho={24}
                onClick={() => setShowAddReparoPopup(false)}
              />
            </div>
            <span className='subtitle'>Selecione abaixo o apontamento</span>
          </HeaderContainer>

          <BodyContainer validWarranty={validWarranty}>
            <FieldContainer>
              <DropDown
                label={'Apontamento'}
                itens={apontamentos}
                idDropDown={'dropDownApontamentos'}
                setValue={setApontamentoSelecionado}
                nomeDropDown='Selecione uma categoria de apontamento que melhor descreva o seu reparo.'
                widthMeuImovel='100%'
                marginLeftMeuImovel='0px'
                nomeSelecionado={apontamentoSelecionado}
                btnClose={false}
                disabled={savingChanges}
                alturaMinima={270}
                altura={40}
              />
              {validWarranty === false &&
                apontamentoSelecionado !==
                  `Selecione uma categoria de apontamento que melhor descreva o seu reparo.` && (
                  <AlertMessage>
                    ESSE APONTAMENTO NÃO ESTÁ MAIS DISPONÍVEL OU ESTÁ FORA DA
                    GARANTIA, POR GENTILEZA CONSULTE O MANUAL DO PROPRIETÁRIO OU
                    ENTRE EM CONTATO COM A CENTRAL DE ATENDIMENTO.
                  </AlertMessage>
                )}
            </FieldContainer>

            {validWarranty && apontamentoSelecionado && (
              <FieldContainer>
                <label>Descrição</label>
                <div className='novaSolicitacao__descricao__text'>
                  <textarea
                    type='text'
                    wrap='soft'
                    maxLength='2000'
                    placeholder='Para dar andamento na sua solicitação de forma assertiva, descreva da melhor forma os pontos principais da sua questão.'
                    onChange={(e) => {
                      setDescricao(e.target.value);
                    }}
                    id='txtAreaDescricao'
                  />
                </div>

                <label className='novaSolicitacao__descricao__obrigatorio'>
                  Campo obrigatório - {2000 - descricao?.length} / 2000
                </label>

                <AttachDocuments
                  documents={documents}
                  setDocuments={setDocuments}
                  tema={tema}
                  isSindico={isSindico}
                />
              </FieldContainer>
            )}
          </BodyContainer>
          <ButtonsContainer>
            <ButtonPrimary
              light
              fullWidth
              onClick={() => setShowAddReparoPopup(false)}
              tema={tema}
            >
              Cancelar
            </ButtonPrimary>
            <ButtonPrimary
              tema={tema}
              fullWidth
              disabled={verificaSeDisabilitado}
              onClick={handleAddReparo}
            >
              ADICIONAR REPARO
            </ButtonPrimary>
          </ButtonsContainer>
        </InfosContainer>
      </PopupAddRepairContainer>
    </PageOverlay>,
    document.getElementById('MessagePopup')
  );
};

export default AddReparoPopup;
